import { Autocomplete, TextField } from '@mui/material';
import { useTranslation } from 'react-i18next';

interface WorkspacePickerProps {
  workspaces: string[];
  selectedWorkspace: string | undefined;
  changeHandler: (wks: string | null) => void;
}

const WorkspacePicker = (props: WorkspacePickerProps) => {
  const { t } = useTranslation();
  return (
    <Autocomplete
      disablePortal
      sx={{ minWidth: '200px' }}
      autoHighlight
      value={props.selectedWorkspace ? props.selectedWorkspace : null}
      options={props.workspaces}
      onChange={(event, values) => props.changeHandler(values)}
      renderInput={(params) => (
        <TextField
          {...params}
          label={t('workspace')}
          inputProps={{
            ...params.inputProps,
            autoComplete: 'new-password'
          }}
        />
      )}
    />
  );
};

export default WorkspacePicker;
